exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j7_Qqab_Is2Vctow-Vmwq{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow:hidden}.HntwxnC7119fUHVjY5l4U{font-weight:600;font-size:12px;font-weight:400}html[dir=ltr] .oVB2KTBuiQcUQgXxfz9jQ{padding-right:5px}html[dir=rtl] .oVB2KTBuiQcUQgXxfz9jQ{padding-left:5px}", ""]);

// exports
exports.locals = {
	"personContainer": "j7_Qqab_Is2Vctow-Vmwq",
	"personaName": "HntwxnC7119fUHVjY5l4U",
	"personaControlContainer": "oVB2KTBuiQcUQgXxfz9jQ"
};